import { gql } from "apollo-boost";

const communities = gql`
  query ($filter: CommunityFilter) {
    communities(filter: $filter) {
      total
      items {
        id
        name
        state
        pricePack
        carpoolFree
        userCount
        division {
          id
          name
        }
        divisionId
        description
        createDate
        status
      }
    }
  }
`;

const community = gql`
  query community($id: String!) {
    community(id: $id) {
      id
      name
      state
      pricePack
      carpoolFree
      zipCodes
      division {
        id
        name
      }
      divisionId
      description
      createDate
      status
    }
  }
`;

export const CommunityMembers = gql`
  query communityMembers($id: String!) {
    communityMembers(id: $id) {
      id
      name
      email
    }
  }
`;

const childcareFare = gql`
  {
    childcareFare
  }
`;

const saveCommunity = gql`
  mutation saveCommunity($input: FmCommunityInput!) {
    saveCommunity(input: $input)
  }
`;

export const SetCommunityLeader = gql`
  mutation setCommunityLeader($id: String!, $leaderId: String) {
    setCommunityLeader(id: $id, leaderId: $leaderId)
  }
`;

export const communityGql = {
  communities,
  community,
  saveCommunity,
  childcareFare,
};
